export const LADIES = [
  {
    slug: 'sarah',
    name: 'Sarah',
    shortEn: 'Warm, elegant companion',
    shortZh: '温柔优雅',
    status: 'available',
  },
  {
    slug: 'momo',
    name: 'Momo',
    shortEn: 'Playful and attentive',
    shortZh: '活泼贴心',
    status: 'next',
  },
  {
    slug: 'amy',
    name: 'Amy',
    shortEn: 'Soft-spoken and refined',
    shortZh: '轻声细语',
    status: 'available',
  },
  {
    slug: 'jisoo',
    name: 'Jisoo',
    shortEn: 'Korean beauty',
    shortZh: '韩系佳丽',
    status: 'limited',
  },
  {
    slug: 'viona',
    name: 'Viona',
    shortEn: 'Confident and charming',
    shortZh: '自信迷人',
    status: 'available',
  },
  {
    slug: 'jay',
    name: 'Jay',
    shortEn: 'Bold and fun',
    shortZh: '大胆有趣',
    status: 'next',
  },
  {
    slug: 'ren',
    name: 'Ren',
    shortEn: 'Calm and sensual',
    shortZh: '沉静感性',
    status: 'new',
  },
  {
    slug: 'sally',
    name: 'Sally',
    shortEn: 'Korean · 19 · 165 cm',
    shortZh: '韩国 · 19岁 · 165cm',
    status: 'available',
    nationality: 'Korean',
    nationalityZh: '韩国',
    age: 19,
    height: '165 cm',
    weight: '45 kg',
    cup: 'C, Natural',
    cupZh: 'C杯 · 天然',
    dress: '6',
    language: 'Korean, English',
    languageZh: '韩语、英语',
    extras: ['Anal', 'COF', 'Filming'],
    extrasZh: ['Anal', 'COF', 'Filming'],
    services: ['Shower together', 'BBBJ', 'DFK', 'DATY', 'CIM', '69', 'Sex'],
    rates: [
      { duration: '30 mins', price: '$200' },
      { duration: '45 mins', price: '$250' },
      { duration: '60 mins', price: '$300' },
    ],
  },
];

export function getLady(slug) {
  return LADIES.find((lady) => lady.slug === slug) || null;
}

export const ROSTER_DAYS = [
  { key: 'mon', en: 'Monday', zh: '周一' },
  { key: 'tue', en: 'Tuesday', zh: '周二' },
  { key: 'wed', en: 'Wednesday', zh: '周三' },
  { key: 'thu', en: 'Thursday', zh: '周四' },
  { key: 'fri', en: 'Friday', zh: '周五' },
  { key: 'sat', en: 'Saturday', zh: '周六' },
  { key: 'sun', en: 'Sunday', zh: '周日' },
];

/** Draft weekly roster using the named ladies until live shifts are connected. */
export const ROSTER = {
  mon: [
    { slug: 'sarah', shift: '10:00 – 18:00' },
    { slug: 'momo', shift: '14:00 – 22:00' },
    { slug: 'sally', shift: '18:00 – 02:00' },
  ],
  tue: [
    { slug: 'amy', shift: '10:00 – 18:00' },
    { slug: 'jisoo', shift: '14:00 – 22:00' },
    { slug: 'jay', shift: '18:00 – 02:00' },
  ],
  wed: [
    { slug: 'viona', shift: '10:00 – 18:00' },
    { slug: 'ren', shift: '14:00 – 22:00' },
    { slug: 'sally', shift: '18:00 – 02:00' },
  ],
  thu: [
    { slug: 'sarah', shift: '12:00 – 20:00' },
    { slug: 'amy', shift: '16:00 – 00:00' },
    { slug: 'momo', shift: '18:00 – 02:00' },
  ],
  fri: [
    { slug: 'jisoo', shift: '12:00 – 20:00' },
    { slug: 'viona', shift: '16:00 – 00:00' },
    { slug: 'jay', shift: '18:00 – 04:00' },
    { slug: 'sally', shift: '20:00 – 04:00' },
  ],
  sat: [
    { slug: 'sarah', shift: '12:00 – 20:00' },
    { slug: 'ren', shift: '14:00 – 22:00' },
    { slug: 'momo', shift: '18:00 – 04:00' },
    { slug: 'amy', shift: '20:00 – 04:00' },
  ],
  sun: [
    { slug: 'viona', shift: '12:00 – 20:00' },
    { slug: 'jisoo', shift: '14:00 – 22:00' },
    { slug: 'sally', shift: '16:00 – 00:00' },
  ],
};

export function langPath(path, language) {
  if (language === 'en') return path === '/' ? '/en' : `/en${path}`;
  return path;
}
